for (const search of document.querySelectorAll(".header__search-wrapper")) {
  const searchIcon = search.querySelector(".header__search-icon");
  const searchForm = search.querySelector(".header__search");

  searchIcon?.addEventListener("click", (e) => {
    e.preventDefault();
    searchForm?.classList.toggle("active");
  });

  window.addEventListener("click", function (e) {
    if (!(e.target instanceof Element)) {
      return;
    }

    if (!document.getElementById("search-box")?.contains(e.target)) {
      searchForm?.classList.remove("active");
    }
  });
}
